import CommandSelect from "@/components/commands/command-select";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Ban,
  CalendarArrowDownIcon,
  CalendarArrowUpIcon,
  Plus,
} from "lucide-react";
import { useMemo } from "react";
import { isDateFilterName } from "../../utils/check-filter-type";
import {
  DateFilterCondition,
  DateFilterName,
  FilterCondition,
  FilterName,
  StringFilterCondition,
  StringFilterName,
} from "../../utils/types";

interface ConditionFilterCommandProps {
  filterKey: FilterName;
  conditionsOptionValues: FilterCondition[];
  value: FilterCondition;
}

export default function ConditionFilterCommand({
  conditionsOptionValues,
  value,
  filterKey,
}: ConditionFilterCommandProps) {
  const t = useTranslation();
  const { updateFilterCondition } = useReturnRequestsFilters();
  const options = useMemo(() => {
    return [
      {
        label: t("misc.filters.in"),
        value: "in",
        Icon: Plus,
      },
      {
        label: t("misc.filters.notIn"),
        value: "notIn",
        Icon: Ban,
      },
      {
        label: t("misc.filters.after"),
        value: "after",
        Icon: CalendarArrowUpIcon,
      },
      {
        label: t("misc.filters.before"),
        value: "before",
        Icon: CalendarArrowDownIcon,
      },
    ].filter((option) =>
      conditionsOptionValues.includes(option.value as FilterCondition),
    );
  }, [conditionsOptionValues, t]);

  return (
    <CommandSelect
      options={options}
      value={value}
      onSelect={(value) => {
        if (isDateFilterName(filterKey)) {
          updateFilterCondition({
            name: filterKey,
            condition: value as FilterCondition,
          } as { name: DateFilterName; condition: DateFilterCondition });
        } else {
          updateFilterCondition({
            name: filterKey,
            condition: value as FilterCondition,
          } as { name: StringFilterName; condition: StringFilterCondition });
        }
      }}
      onClear={() => {}}
      withInput={false}
      withClear={false}
    />
  );
}
